'use client';

import { ServerActionName } from '@headless-workspace/config';
import { CONTENT_ASSET_KEYS, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { getContentAssetServerAction } from '../../../server';
import { useSafeSWR } from '../hooks';
import { UserRevalidationKey } from '../user';

export const useContentAssets = (contentAssetKeys: CONTENT_ASSET_KEYS[]) => {
    const { data, isLoading, error } = useSafeSWR(
        [UserRevalidationKey.ContentAsset, ...contentAssetKeys],
        ServerActionName.getContentAssetServerAction,
        () => getContentAssetServerAction(contentAssetKeys),
    );

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure('error', error instanceof Error ? error.message : ''),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: data };
};
